<div id="{{this.propertyId}}FormCore"  [formGroup]="this.formGroup" *ngIf="this.formGroup" >  
    <h2 class="mt-40">Classification unit</h2>

    <div>
    <div class="row mt-20">
        <div class="col-md-9">
            <p>Each business that registers for coverage with WorkSafeBC is grouped with other, similar businesses under a classification unit. Classification units are based on the products and services a business provides and the equipment it uses.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-md-9">
            <p>Others in your industry will share the same classification unit and pay the same base premium rate. You can learn more about classification units on  <a target="_blank" href="{{this.worksafebcbcUrl}}">worksafebc.com</a>.</p>
        </div>
    </div>

    <div class="row">
        <div class="col-md-9">
            <p>The following questions will help us determine the business's classification unit. Please answer them in a way that reflects your current business's operations. If your operations change in the future, we can determine if your classification unit should change too. </p>
        </div>
    </div>
    </div>   

    <div id="summaryOfOperations" >
        <div class="row">
            <div class="col-md-9">
                <app-text-box
                    label="Provide a detailed description of the business operations in B.C."
                    subText = "Please include activities performed, products manufactured, services provided, and any specialized equipment you may use."
                    propertyName="searchKey" 
                    autocomplete="off"   
                    [FIELD_SPACING]="0"
                    [formGroup]="this.formGroup">
                </app-text-box>  
            </div>
        </div>    
        
        <div class="row">
            <div class="col-md-9">
                <app-boolean-field-v2
                    label= "Does your business have multiple revenue streams?"
                    propertyName="hasMultipleRevenueStreams" 
                    [formGroup]="this.formGroup"
                    (userInput)="this.onHasMultipleRevenueStreamsChange($event)"
                    [FIELD_SPACING]="3">
                </app-boolean-field-v2> 
            </div>
        </div>  
        
        <div class="row"  *ngIf="this.formGroup.value?.hasMultipleRevenueStreams =='Y'">
            <div class="col-md-9 mt-20">  
                <p><span class="label">Enter the estimated revenue breakdown of the business operations</span><br/>
                    List up to three revenue streams and the approximate percentage each contributes to the business's overall revenue. </p>
                <p *ngIf="this.classificationSearchViewCoreFunctions.totalPercentage !=null && this.classificationSearchViewCoreFunctions.totalPercentage != 100 " class="mt-1 form-text text-danger"> {{this.totalPercentageEqual100}} </p>
                
            </div>
        </div>  
        
        <div  *ngIf="this.formGroup.value?.hasMultipleRevenueStreams =='Y'">       
            <div id="productDetailsSection" class="row"  *ngFor="let p of this.classificationSearchViewCoreFunctions.listProductDetails;">  
                <div *ngIf="this.formGroup.get(p.description) != null && p.id <= this.classificationSearchViewCoreFunctions.numberOfProductDetails">
                    <div class="form-group row align-items-top">
                        <div class="col-12 col-md-4">                         
                            <label>Revenue stream</label>
                            <div class="input-group" [ngClass]="{'is-invalid': this.isInvalidAndTouched(this.formGroup, p.description)}" >
                                <input type="text" 
                                    class="form-control"
                                    id="{{p.description}}"
                                    formControlName="{{p.description}}"
                                    autocomplete="off"
                                    maxLength="45">                           
                            </div> 
                            <app-validator-message [formGroup]="this.formGroup" propertyName="{{p.description}}"></app-validator-message>
                        </div>

                        <div class="col-12 col-md-3">                     
                            <label>Percentage of revenue</label>                      
                            <div class="input-group flex-nowrap" [ngClass]="{'is-invalid': this.isInvalidAndTouched(this.formGroup, p.percentage)}" >
                                <input type="text" 
                                    class="form-control" 
                                    id="{{p.percentage}}" 
                                    formControlName="{{p.percentage}}"    
                                    autocomplete="off"                        
                                    maxlength='3' 
                                    mask="percent"
                                    min="0"
                                    pattern="[0-9]*"
                                    max="100">
                                <div class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                            <app-validator-message [formGroup]="this.formGroup" propertyName="{{p.percentage}}"></app-validator-message>                      
                        </div>  
                       
                        <div class="col-12 col-md-2" *ngIf="p.id > 1 && p.id == this.classificationSearchViewCoreFunctions.numberOfProductDetails">        
                            <div class="col-md-12 remove-revenue-stream-btn" >
                                <a id="removeModelAndYearLink"  (click)="removeProductDetails(p.id)" href="javascript:void(0)">Remove</a>
                            </div>
                        </div> 
                    </div>     
                </div>  
            </div> 

            <div class="row" *ngIf="this.classificationSearchViewCoreFunctions.numberOfProductDetails < 3" >
                <div class="col-md-12"> 
                    <a id="addModelAndYearLink" (click)="addNewProductDetails()" href="javascript:void(0)" >Add another revenue stream</a>   
                </div>
            </div>          

         </div> 

    </div> 

    <div class="row mt-30">
        <div class="col-md-8">            

            <button id="search" 
            type="button" 
            class="btn btn-md btn-blue mr-1 mb-1" 
            (click)="searchCU()" 
            [disabled] = "disableSearch()"
            style="width: auto;">Select your classification unit</button>                         
        </div>
    </div>

    <div id={{this.propertyId}}  *ngIf="this.isSearchButtonClicked()">
        <div class="row mt-40" *ngIf="this.getClassificationUnits().length > 0">
            <div class="col-md-9">
                <h3 class="tablewrap-title">Based on the information you provided earlier, please review the classification descriptions below, and select the option that reflects your current business operations.<app-help-tooltip id="cu_list_title"  [tooltipMessage]="this.tooltip"></app-help-tooltip></h3>
            </div>
        </div>    
       
        <div class="row" *ngIf="this.getClassificationUnits().length > 0">
            <div class="tablewrap col-md-9">
                <div class="table-responsive">                    
                    <table class="table table-dotted">   
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Classification name</th>
                                <th>Description</th>
                            </tr>
                        </thead>                               
                        <tbody class="roundedtable">
                            <tr *ngFor="let c of this.getClassificationUnits(); let i=index;">
                                <td class="pl-3">
                                    <label class="container-radio ml-3"  for={{i}}>
                                        <input id={{i}} type="radio" formControlName="classificationUnit"  value="{{c.classId}}" checked="" (click)="this.saveScore(c.classId)">
                                        <span class="checkmark"></span>
                                    </label>                                          
                                </td>     
                                <td>
                                    <div *ngIf="i != (this.getClassificationUnits().length -1)">
                                        <p class="my-0"><b>{{c.description}}</b></p>
                                        <br *ngIf="showClassDescription">
                                        <p class="class-description" *ngIf="showClassDescription">{{c.classDescription}}</p>
                                    </div>
                                    <div *ngIf="i == (this.getClassificationUnits().length -1)">
                                        <p class="my-0 pb-1"><b>{{c.description}}</b></p>                                       
                                    </div> 
                                                                                   
                                </td>
                                <td class = "download-pdf">		
                                    <div *ngIf="c.classificationUnitCode > 0 && showDownloadPdf" >                                                     
                                        <button class="far fa-file-pdf cursor-hand-pointer d-flex justify-content-center download-button" (click)="this.commonFunctions.openClassificationPDF(c.classificationUnitCode)"> 
                                            <span class="ps-2 pdf-text"><b>Download PDF</b></span>
                                        </button>                                                  
                                </div>   
                                <div *ngIf="c.classificationUnitCode > 0 && !showDownloadPdf" >                                                     
                                    <button class="far fa-file-pdf cursor-hand-pointer d-flex justify-content-center" (click)="this.commonFunctions.openClassificationPDF(c.classificationUnitCode)"> 
                                    </button>                                                  
                            </div>         
                            </td>    
                            </tr>     
                        </tbody>
                    </table>                    
                </div>                      
            </div>            
        </div>        
                
    </div>   
    
    
    <div id="noCuFound"  class="row mt-40 mb-10" *ngIf="foundClassification === 'N'"> 
        <div class="col-sm-9">
            <blockquote class="blockquote-border-yellow">
                <p>Based on the information you've provided about your business, we will review your application and assign the business a classification unit. Please continue with your application.</p>
            </blockquote>         
        </div>  
    </div>

    <app-loading-spinner customClass = "customLeft" *ngIf="this.loadingFromApi"></app-loading-spinner> 
</div>